
define('text!templates/footer.ejs',[],function () { return '<div class="container" style="display:none">\n  <div class="copyright">\n    © 2013 Ciritas. All rights reserved.\n  </div>\n</div>';});

